import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Plus, Calendar, Trash, MapPin } from "@phosphor-icons/react";

export default function Appointments() {
  const [items, setItems] = useState([]);
  const [adding, setAdding] = useState(false);
  const [form, setForm] = useState({ title: "", doctor: "", location: "", date_time: "", notes: "" });

  const load = async () => { const r = await api.get("/appointments"); setItems(r.data); };
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/appointments", form);
      toast.success("Appointment scheduled.");
      setForm({ title: "", doctor: "", location: "", date_time: "", notes: "" });
      setAdding(false);
      load();
    } catch { toast.error("Could not save."); }
  };

  const del = async (id) => { await api.delete(`/appointments/${id}`); load(); };

  return (
    <div className="space-y-8" data-testid="appointments-page">
      <header className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <p className="overline text-saffron mb-2">Schedule</p>
          <h1 className="font-serif font-semibold text-4xl sm:text-5xl">Appointments</h1>
          <p className="text-ink-700 mt-2">Doctor visits, scans, classes — all in one quiet place.</p>
        </div>
        <button onClick={() => setAdding(!adding)} className="btn-primary" data-testid="add-appointment-btn"><Plus weight="thin" size={18} /> Add appointment</button>
      </header>

      {adding && (
        <form onSubmit={submit} className="vansha-card p-6 space-y-5" data-testid="appointment-form">
          <div className="grid sm:grid-cols-2 gap-5">
            <div><label className="overline mb-2 block">Title</label><input required value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} className="input-line" placeholder="20-week scan" data-testid="appt-title" /></div>
            <div><label className="overline mb-2 block">Date & time</label><input type="datetime-local" required value={form.date_time} onChange={(e) => setForm({ ...form, date_time: e.target.value })} className="input-line" data-testid="appt-datetime" /></div>
            <div><label className="overline mb-2 block">Doctor</label><input value={form.doctor} onChange={(e) => setForm({ ...form, doctor: e.target.value })} className="input-line" placeholder="Dr. Sharma" data-testid="appt-doctor" /></div>
            <div><label className="overline mb-2 block">Location</label><input value={form.location} onChange={(e) => setForm({ ...form, location: e.target.value })} className="input-line" placeholder="Apollo Hospital" data-testid="appt-location" /></div>
          </div>
          <div><label className="overline mb-2 block">Notes</label><textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className="input-line" rows="2" data-testid="appt-notes" /></div>
          <div className="flex gap-3">
            <button type="button" onClick={() => setAdding(false)} className="btn-ghost">Cancel</button>
            <button type="submit" className="btn-primary" data-testid="appt-submit">Save</button>
          </div>
        </form>
      )}

      {items.length === 0 ? (
        <p className="text-ink-500" data-testid="appointments-empty">No appointments yet.</p>
      ) : (
        <div className="space-y-4">
          {items.map((a) => (
            <div key={a.id} className="vansha-card p-6 flex items-start justify-between gap-4" data-testid={`appointment-${a.id}`}>
              <div className="flex gap-4">
                <div className="text-center bg-vansha-accent rounded-xl p-3 min-w-[64px]">
                  <p className="font-serif text-2xl text-terracotta leading-none">{new Date(a.date_time).getDate()}</p>
                  <p className="overline mt-1">{new Date(a.date_time).toLocaleString("en", { month: "short" })}</p>
                </div>
                <div>
                  <h3 className="font-serif text-2xl">{a.title}</h3>
                  <p className="text-sm text-ink-500 mt-1">{new Date(a.date_time).toLocaleString()}</p>
                  <div className="flex flex-wrap gap-4 mt-2 text-sm text-ink-700">
                    {a.doctor && <span>{a.doctor}</span>}
                    {a.location && <span className="flex items-center gap-1"><MapPin weight="thin" size={14} />{a.location}</span>}
                  </div>
                  {a.notes && <p className="text-sm text-ink-700 mt-2">{a.notes}</p>}
                </div>
              </div>
              <button onClick={() => del(a.id)} className="btn-ghost p-2" data-testid={`del-appt-${a.id}`}><Trash weight="thin" size={18} /></button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
